import { Reveal } from "@/components/motion";

const SectionHeading = ({ eyebrow, title, sub, dark = false, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-coacher-red" style={align === "center" ? { justifyContent: "center" } : undefined}>
        <span className="inline-block h-px w-8 bg-coacher-red" aria-hidden="true" />
        {eyebrow}
        {align === "center" && <span className="inline-block h-px w-8 bg-coacher-red" aria-hidden="true" />}
      </p>
    )}
    <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold uppercase leading-[1.05] tracking-tight ${dark ? "text-white" : "text-coacher-navy"}`}>
      {title}
    </h2>
    {sub && <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-white/70" : "text-coacher-slate"}`}>{sub}</p>}
  </Reveal>
);

export default SectionHeading;
